import { render } from "./PaymentTransactionUpdate.vue?vue&type=template&id=35a8eee1"
import script from "./PaymentTransactionUpdate.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__